import React from "react"
import Triangle from "../triangle/triangle"

const CARDS = [
  {
    sector: "eCommerce",
    title: "National fashion retailer",
    spend: "c.£12.5k",
    results: [
      "£1.95m in online revenue from Google Ads in the last 12 months",
      "12.9x ROAS, which is nearly £13 back for every £1 spent",
      "Revenue up 6% year on year while spend came down 7%",
      "Cost per sale down 13% year on year",
      "Peak season: £767k revenue in Q4 2025 at 14.4x ROAS",
      "£5.5m revenue generated over three years",
    ],
  },
  {
    sector: "eCommerce / education",
    title: "National training provider",
    spend: "c.£48k",
    results: [
      "Online course bookings up 57% year on year",
      "Course revenue up 61% on just 13% more spend",
      "Cost per booking down 28% (£259 to £186)",
      "Return on ad spend up 43%",
      "Over £580k a year in ad spend under management",
    ],
  },
  {
    sector: "Lead generation",
    title: "Home improvement specialist",
    spend: "c.£17.5k",
    results: [
      "Ad spend doubled year on year (+105%)",
      "Enquiries nearly doubled at the same time (+95%)",
      "Cost per enquiry held within 5% while scaling",
      "3,600+ enquiries in the last 12 months",
    ],
  },
]

const HighSpendCaseStudies = () => (
  <section className="pb-12 md:pb-16 xl:pb-20">
    <div className="container">
      <h2 className="mb-12 text-center">The result speak for themselves...</h2>
      <div className="high-spend-case-studies__scroller flex overflow-x-auto lg:flex-wrap lg:overflow-visible lg:-mx-4">
        {CARDS.map((card) => (
          <article className="high-spend-case-studies__card flex-none lg:w-1/3 lg:px-4" key={card.title}>
            <div className="h-full border-2 border-grey">
              <header className="p-6 bg-secondary-dark">
                <p className="mb-2 text-sm text-white">{card.sector}</p>
                <p className="mb-5 text-xl leading-tight text-white font-display">{card.title}</p>
                <p className="mb-1 text-4xl leading-none font-display text-secondary-light">{card.spend}</p>
                <p className="mb-0 text-sm text-white">[monthly ad spend managed]</p>
              </header>
              <div className="p-6 bg-white">
                <ul className="p-0 m-0 list-none">
                  {card.results.map((result) => (
                    <li className="flex mb-3" key={result}>
                      <span className="inline-block w-auto mt-1 mr-3 text-primary">
                        <Triangle size={`small`} />
                      </span>
                      <span className="flex-1 text-base">{result}</span>
                    </li>
                  ))}
                </ul>
                {card.summary ? (
                  <p className="mt-4 mb-0 text-base">{card.summary}</p>
                ) : null}
                {card.href ? (
                  <a href={card.href} className="mt-6 btn btn--outline">Read more</a>
                ) : null}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default HighSpendCaseStudies
